'use strict';

angular.module('MoreAppsServices').factory('$adminUserDataService', ['moreConstants', '$resource', function (moreConstants, $resource) {
  const self = this;
  self.user = null;
  self.usernameQuery = null;

  self.reset = function () {
    self.usernameQuery = null;
    self.user = null;
  };

  return {
    getUser: function () {
      return self.user;
    },
    setUser: function (newUserData) {
      self.user = newUserData;
    },

    getUsernameQuery: function () {
      return self.usernameQuery;
    },
    setUsernameQuery: function (usernameQuery) {
      if (self.usernameQuery !== usernameQuery) {
        self.reset();
      }
      self.usernameQuery = usernameQuery;
    },

    reset: function () {
      self.reset();
    }
  };
}]);